import React from 'react';
import Drawer, {
    DrawerHeader,
    DrawerTitle,
    DrawerContent,
} from '@material/react-drawer';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { IoIosClose } from "react-icons/io";
import "@material/react-drawer/dist/drawer.css";
import './Cart.scss';
import { Button } from 'react-bootstrap';
import ShopHOC from '../../../hoc/ShopHOC';
import CartContents from './CartContents/CartContents';
import { useTranslation } from 'react-i18next';

function Cart(props) {
    const { t } = useTranslation();
    const { cartOpen, handleCartOpen, cartOrder, checkout, partnerPortalSettings, setProductQuantity, removeProductFromCart, orderRowsMeta } = props;
    let { url } = useRouteMatch();

    return (
        <React.Fragment>
            {cartOpen ?
                <Drawer 
                    className="shoppingCart"
                    modal
                    open={cartOpen}
                    onClose={() => handleCartOpen(false)}
                    dismissible={false}>
                    <DrawerHeader className="cartHeader">
                        <DrawerTitle tag='h1'>
                            <button className="closeCartBtn" variant="light">
                                <IoIosClose className="closeBtn" onClick={() => handleCartOpen(false)}/>
                            </button>
                            {t('events.cart')}
                            <hr/>
                        </DrawerTitle>
                    </DrawerHeader>
            
                    <DrawerContent className="cartContent" tag='main'>
                        <CartContents 
                            cartOrder={cartOrder} 
                            orderRowsMeta={orderRowsMeta}
                            removeProductFromCart={removeProductFromCart}
                            setProductQuantity={setProductQuantity}
                            partnerPortalSettings={partnerPortalSettings}
                            checkout={checkout}>
                        </CartContents>

                        <div className="cartActions">
                            <Button className="cartActionBtn" variant="light" onClick={() => handleCartOpen(false)}>{t('general.close')}</Button>
                            <Button className={"cartActionBtn " + (!cartOrder.orderRows.length ? 'disabled-btn' : '')} disabled={!cartOrder.orderRows.length} onClick={() => handleCartOpen(false)}>
                                {!cartOrder.orderRows.length ? <span>{t('events.checkout')}</span> : <NavLink to={`${url}/checkout`}>{t('events.checkout')}</NavLink>}
                            </Button>
                        </div>
                    </DrawerContent>
                </Drawer>
            : null}
        </React.Fragment>
    )
}



export default ShopHOC(Cart);